import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRfidFileDownload = (fileIds) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'downloadRfidFile',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, JSON.stringify({ fileIds }), {
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  });
};

export default apiFetchRfidFileDownload;
